import Vue from "vue";
import Router from "vue-router";
import LoadInitialAB from "./views/LoadInitialAB.vue";
import Initial from "./views/Initial.vue";
import SignUp from "./views/SignUp.vue";
import InvalidVerify from "@/components/Signup/InvalidVerify.vue";
import ProfileBuild from "@/components/Signup/ProfileBuild.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "initial",
      component: Initial,
    },
    {
      path: "/verify/:token",
      name: "verify",
      component: SignUp,
    },
    {
      path: "/verify",
      name: "verifynotoken",
      component: SignUp,
    },
    {
      path: "/verify/invalid",
      name: "verifyinvalid",
      component: InvalidVerify,
    },
    {
      path: "/building",
      name: "building",
      component: ProfileBuild,
      props: true,
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});
